import { type ProgramDefinitionDto, useProgramDefinition } from "@repo/data-store";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { CatalogDefinition, ProgramRead } from "@/features/catalog";
import { useDefinitionChangePoints, useDefinitionView } from "@/features/catalog/hooks/use-definition-as-of";
import { asOfSearchSchema } from "@/features/catalog/lib/as-of-search";
import { programDefinitionUrlFromRouteId } from "@/features/catalog/lib/program-definition-route";

export const Route = createFileRoute("/catalog/procedures/$procedureId")({
  component: ProcedureDetailComponent,
  validateSearch: asOfSearchSchema,
});

function ProcedureDetailComponent() {
  const { procedureId } = Route.useParams();
  const { asOf } = Route.useSearch();
  const { permissions } = Route.useRouteContext();
  const navigate = useNavigate();
  const definitionUrl = programDefinitionUrlFromRouteId(procedureId);
  const live = useProgramDefinition(asOf ? undefined : definitionUrl);
  const view = useDefinitionView<ProgramDefinitionDto>(definitionUrl, asOf, live);
  const { changePoints } = useDefinitionChangePoints(definitionUrl);

  if (view.isPending) return <CatalogDefinition.Pending />;
  if (!view.definition) {
    return <CatalogDefinition.NotFound label="Item" backTo="/catalog/procedures" backLabel="Back to procedures" />;
  }

  return (
    <ProgramRead
      key={`${procedureId}|${asOf ?? "latest"}`}
      definition={view.definition}
      procedureId={procedureId}
      asOf={asOf}
      changePoints={changePoints}
      canEdit={!view.isPast && permissions.canWrite("PlanDefinition")}
      onArchived={() => navigate({ to: "/catalog/procedures" })}
    />
  );
}
